import React from 'react';
import { Box, Typography } from '@mui/material';
import { COLORS } from '../../pages/app/reports/groups-teams-activity/constants';

interface BreadcrumbSegment {
    label: string;
    onClick?: () => void;
}

interface BreadcrumbNavProps {
    segments: BreadcrumbSegment[];
}

export const BreadcrumbNav: React.FC<BreadcrumbNavProps> = ({ segments }) => {
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                marginBottom: '6px',
                fontSize: '12px',
                flexWrap: 'wrap',
            }}
        >
            {segments.map((seg, idx) => {
                const isLast = idx === segments.length - 1;
                return (
                    <React.Fragment key={idx}>
                        {idx > 0 && (
                            <Typography
                                component="span"
                                sx={{ color: '#C4C9D2', fontSize: '12px' }}
                            >
                                &#8250;
                            </Typography>
                        )}
                        {isLast ? (
                            <Typography
                                component="span"
                                sx={{ color: COLORS.grayDark, fontSize: '12px' }}
                            >
                                {seg.label}
                            </Typography>
                        ) : (
                            <Typography
                                component="span"
                                onClick={seg.onClick}
                                sx={{
                                    color: COLORS.primary,
                                    fontSize: '12px',
                                    fontWeight: 500,
                                    cursor: seg.onClick ? 'pointer' : 'default',
                                    textDecoration: 'none',
                                    '&:hover': seg.onClick ? { textDecoration: 'underline' } : {},
                                }}
                            >
                                {seg.label}
                            </Typography>
                        )}
                    </React.Fragment>
                );
            })}
        </Box>
    );
};
